module.exports = __webpack_public_path__ + "static/img/join1.2f7ddeb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/join/join1.png
// module id = hkgV
// module chunks = 11